import { render, staticRenderFns } from "./detail_infosection.vue?vue&type=template&id=6f8f7089&"
import script from "./detail_infosection.vue?vue&type=script&lang=js&"
export * from "./detail_infosection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports